module.exports = __webpack_public_path__ + "img/loading-end.f81e00d.png";